import { Injectable } from '@angular/core';
import { createRequestsCacheOperator, updateRequestCache, withRequestsCache } from '@ngneat/elf-requests';
import { createStore, select } from '@ngneat/elf';
import { ContinuousPaginationBookCardsDTO } from '../models/publication';
import { addEntities, getEntity, withEntities } from '@ngneat/elf-entities';
import { map, Observable } from 'rxjs';
interface DoctrinalFactSheetState {
    doctrinalFactSheets: ContinuousPaginationBookCardsDTO;
    filterStringify: string;
}
const store = createStore(
    { name: 'doctrinalFactSheet' },
    withEntities<DoctrinalFactSheetState, 'filterStringify'>({
        idKey: 'filterStringify'
    }),
    withRequestsCache<'doctrinal-fact-sheets' | `doctrinal-fact-sheets-${string}`>()
);
export const skipWhileDoctrinalFactSheetCached = createRequestsCacheOperator(store);
export const CACHE_KEY_DOCTRINAL_FACT_SHEET = 'doctrinal-fact-sheets';

@Injectable({ providedIn: 'root' })
export class DoctrinalFactSheetRepository {
    getDoctrinalFactSheets(filterStringify: string): Observable<ContinuousPaginationBookCardsDTO> {
        return store.pipe(
            select(getEntity(filterStringify)),
            map(state => state.doctrinalFactSheets)
        );
    }

    setDoctrinalFactSheets(payload: ContinuousPaginationBookCardsDTO, filterStringify: string): void {
        store.update(
            updateRequestCache(`${CACHE_KEY_DOCTRINAL_FACT_SHEET}-${filterStringify}`),
            addEntities({ filterStringify, doctrinalFactSheets: payload })
        );
    }
}
